import { useState } from 'react'
import { useMediaQuery } from 'react-responsive'

import certificateImg from '@/assets/images/health-certificate.webp'
import { ReactComponent as IconLeft } from '@/assets/images/icons/icon-left.svg'

import styles from './Medical.module.scss'

const infoTexts = [
  'Печать медицинской организации, на которой идентифицируется полное наименование медицинской организации в ' +
  'соответствии с учредительными документами.',
  'Штамп медицинской организации / бланк медицинской организации с её реквизитами.',
  'Личная подпись и личная печать врача (должны друг другу соответствовать).',
]

function Medical() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const [activeText, setActiveText] = useState(0)
  const lengthTexts = infoTexts.length - 1

  const handleNextText = () => {
    if (activeText < lengthTexts) {
      setActiveText((prev) => prev + 1)
    } else {
      setActiveText(0)
    }
  }

  const handlePrevText = () => {
    if (activeText > 0) {
      setActiveText((prev) => prev - 1)
    } else {
      setActiveText(lengthTexts)
    }
  }

  return (
    <section className={styles.medical} id="medical">
      <div className={styles.inner}>
        <h2 className={styles.title}>Медицинская справка</h2>

        <div className={styles.main}>
          <div className={styles.medWrap}>
            <div className={styles.certificateWrap}>
              <p className={styles.medLabel}>Справка должна содержать следующие сведения:</p>

              <img className={`${styles.img} lazyload`} src={certificateImg} width={369} height={252} alt="" />

              {!isMobile && (
                <div className={styles.descWrap}>
                  <p className={styles.desc}>
                    В соответствии c Приказом Министерства Здравоохранения Российской Федерации от 23 октября 2020 г
                    №1144н допуск к учебно-тренировочной и соревновательной деятельности выдается спортсмену на срок 6
                    месяцев.
                  </p>

                  <p className={styles.desc}>
                    Форма – допуск в соответствии с Приказом Министерства Здравоохранения Российской Федерации от 23
                    октября 2020 г №1144н
                  </p>
                </div>
              )}
            </div>

            <div className={styles.info}>
              <p className={styles.infoText}>{infoTexts[activeText]}</p>
              <div className={styles.buttons}>
                <button className={`${styles.button} ${styles.buttonPrev}`} onClick={handlePrevText}>
                  <span className="visually-hidden">Предыдущий</span>
                  <IconLeft />
                </button>
                <button className={`${styles.button} ${styles.buttonNext}`} onClick={handleNextText}>
                  <span className="visually-hidden">Следующий</span>
                  <IconLeft className={styles.iconNext} />
                </button>
              </div>
            </div>

            {isMobile && (
              <div className={styles.descWrap}>
                <p className={styles.desc}>
                  В соответствии c Приказом Министерства Здравоохранения Российской Федерации от 23 октября 2020 г
                  №1144н допуск к учебно-тренировочной и соревновательной деятельности выдается спортсмену на срок 6
                  месяцев.
                </p>

                <p className={styles.desc}>
                  Форма – допуск в соответствии с Приказом Министерства Здравоохранения Российской Федерации от 23
                  октября 2020 г №1144н
                </p>
              </div>
            )}
          </div>

          <div className={styles.items}>
            <p className={styles.item}>
              <span className={styles.itemLabel}>Данные пациента</span> <span className={styles.itemValue}>ФИО</span>
            </p>

            <p className={styles.item}>
              <span className={styles.itemLabel}>
                <span>Дата рождения</span>
                {isMobile && (
                  <span className={`${styles.itemFootnote} ${styles.itemFootnoteAge}`}>
                    Для несовершеннолетних с указанием полных лет.
                  </span>
                )}
              </span>
              <span className={`${styles.itemValue} ${styles.itemValueAge}`}>
                <span>01.10.1991</span>
                {!isMobile && (
                  <span className={`${styles.itemFootnote} ${styles.itemFootnoteAge}`}>
                    Для несовершеннолетних с указанием полных лет.
                  </span>
                )}
              </span>
            </p>

            <p className={styles.item}>
              <span className={styles.itemLabel}>Вид спорта</span> <span className={styles.itemValue}>бег</span>
            </p>

            <p className={styles.item}>
              <span className={styles.itemLabel}>Дистанция</span>
              <span className={styles.itemValue}> 1, 5, 10 или 21.1 км</span>
            </p>

            <p className={styles.item}>
              <span className={styles.itemLabel}>
                <span>Название мероприятия</span>
                <span className={`${styles.itemFootnote} ${styles.itemLabelFootnote}`}>Указывать необязательно.</span>
              </span>
              <span className={styles.itemValue}> забег.рф</span>
            </p>

            <p className={`${styles.item} ${styles.itemLong}`}>
              <span className={styles.itemLabel}>
                Результаты осмотра <br /> врача-терапевта
              </span>
              <span className={styles.itemValue}> противопоказаний к забегу на дистанции 1, 5, 10 или 21.1 км нет</span>
            </p>

            <p className={`${styles.item} ${styles.itemLong}`}>
              <span className={styles.itemLabel}>Результат ЭКГ</span>
              <span className={styles.itemValue}>полное описание результатов ЭКГ(расшифровка)</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Medical
